// libs
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'

// components
import Reactions, { IReactionsProps } from 'src/components/post/shared/reactions/reactions'
import UserOnboardingCTA from 'src/containers/smart_components/user_onboarding_cta/user_onboarding_cta'

// helpers
import { translateReactions } from 'src/utils/reactions'

import { ReactionName } from '@lopo-tech/lopo-api'
import { FC } from 'react'
import './post_detail_reaction_wrapper.scss'

const cls = CLASS_PREFIX + 'post__detail__reactions'
const clsWrapper = cls + '-wrapper'

const PostDetailReactionWrapper: FC<IReactionsProps & {canReact: boolean}> = (props) => {
  const { reactions, canReact } = props

  const isCandlePost = reactions.availableReactions.length === 1 && reactions.availableReactions[0] === ReactionName.Candle

  return (
    <>
      {isCandlePost
        ? <h2 className={cls + '__headline'}>
          {translateReactions(ReactionName.Candle)}
        </h2>
        : <div className={cls + '__spacer'} />}
      <UserOnboardingCTA active={!canReact} gtmSourceName='canBookmark'>
        <div className={clsWrapper}>
          <Reactions {...props} />
        </div>
      </UserOnboardingCTA>
    </>
  )
}

export default PostDetailReactionWrapper
